export enum Lang {
  EN = 'en',
  DE = 'de',
  FR = 'fr',
  IT = 'it',
  ES = 'es',
  PT = 'pt',
  NL = 'nl',
  PL = 'pl',
}

export const LANGUAGES: { code: Lang; label: string }[] = [
  { code: Lang.EN, label: 'English' },
  { code: Lang.DE, label: 'Deutsch' },
  { code: Lang.FR, label: 'Français' },
  { code: Lang.IT, label: 'Italiano' },
  { code: Lang.ES, label: 'Español' },
  { code: Lang.PT, label: 'Português' },
  { code: Lang.NL, label: 'Nederlands' },
  { code: Lang.PL, label: 'Polski' },
];

const dict = {
  // ── Navbar ──
  'nav.features': {
    en: 'Features',
    de: 'Funktionen',
    fr: 'Fonctionnalités',
    it: 'Funzionalità',
    es: 'Funciones',
    pt: 'Funcionalidades',
    nl: 'Functies',
    pl: 'Funkcje',
  },
  'nav.howItWorks': {
    en: 'How It Works',
    de: 'So funktioniert\u2019s',
    fr: 'Comment ça marche',
    it: 'Come funziona',
    es: 'Cómo funciona',
    pt: 'Como funciona',
    nl: 'Hoe het werkt',
    pl: 'Jak to działa',
  },
  'nav.pricing': {
    en: 'Pricing',
    de: 'Preise',
    fr: 'Tarifs',
    it: 'Prezzi',
    es: 'Precios',
    pt: 'Preços',
    nl: 'Prijzen',
    pl: 'Cennik',
  },
  'nav.customers': {
    en: 'Customers',
    de: 'Kunden',
    fr: 'Clients',
    it: 'Clienti',
    es: 'Clientes',
    pt: 'Clientes',
    nl: 'Klanten',
    pl: 'Klienci',
  },
  'nav.login': {
    en: 'Log in',
    de: 'Anmelden',
    fr: 'Connexion',
    it: 'Accedi',
    es: 'Iniciar sesión',
    pt: 'Entrar',
    nl: 'Inloggen',
    pl: 'Zaloguj się',
  },
  'nav.getStarted': {
    en: 'Get Started Free',
    de: 'Kostenlos starten',
    fr: 'Commencer gratuitement',
    it: 'Inizia gratis',
    es: 'Empezar gratis',
    pt: 'Começar grátis',
    nl: 'Gratis starten',
    pl: 'Zacznij za darmo',
  },

  // ── Hero ──
  'hero.badge': {
    en: 'Fire Safety Compliance Platform',
    de: 'Plattform für Brandschutz-Compliance',
    fr: 'Plateforme de conformité sécurité incendie',
    it: 'Piattaforma conformità antincendio',
    es: 'Plataforma de cumplimiento contra incendios',
    pt: 'Plataforma de conformidade contra incêndios',
    nl: 'Brandveiligheid compliance platform',
    pl: 'Platforma zgodności ochrony przeciwpożarowej',
  },
  'hero.title1': {
    en: 'Every Fire Extinguisher.',
    de: 'Jeder Feuerlöscher.',
    fr: 'Chaque extincteur.',
    it: 'Ogni estintore.',
    es: 'Cada extintor.',
    pt: 'Cada extintor.',
    nl: 'Elke brandblusser.',
    pl: 'Każda gaśnica.',
  },
  'hero.title2': {
    en: 'Accounted For.',
    de: 'Erfasst.',
    fr: 'Sous contrôle.',
    it: 'Sotto controllo.',
    es: 'Bajo control.',
    pt: 'Sob controle.',
    nl: 'Onder controle.',
    pl: 'Pod kontrolą.',
  },
  'hero.sub': {
    en: 'Stop managing fire safety with spreadsheets. Track every asset, automate compliance reminders, and generate audit-ready reports — across all your locations.',
    de: 'Schluss mit Brandschutz per Tabellenkalkulation. Erfassen Sie jedes Gerät, automatisieren Sie Compliance-Erinnerungen und erstellen Sie prüfungsbereite Berichte — standortübergreifend.',
    fr: 'Arrêtez de gérer la sécurité incendie avec des tableurs. Suivez chaque équipement, automatisez les rappels de conformité et générez des rapports prêts pour l\u2019audit — sur tous vos sites.',
    it: 'Basta gestire la sicurezza antincendio con i fogli di calcolo. Monitora ogni dispositivo, automatizza i promemoria di conformità e genera report pronti per l\u2019audit — in tutte le sedi.',
    es: 'Deja de gestionar la seguridad contra incendios con hojas de cálculo. Rastrea cada activo, automatiza recordatorios de cumplimiento y genera informes listos para auditoría — en todas tus ubicaciones.',
    pt: 'Pare de gerenciar segurança contra incêndios com planilhas. Rastreie cada ativo, automatize lembretes de conformidade e gere relatórios prontos para auditoria — em todas as suas localidades.',
    nl: 'Stop met brandveiligheid beheren via spreadsheets. Volg elk apparaat, automatiseer compliance-herinneringen en genereer auditklare rapporten — op al uw locaties.',
    pl: 'Przestań zarządzać ochroną przeciwpożarową za pomocą arkuszy kalkulacyjnych. Śledź każdy zasób, automatyzuj przypomnienia o zgodności i generuj raporty gotowe do audytu — we wszystkich lokalizacjach.',
  },
  'hero.startTrial': {
    en: 'Start Free Trial',
    de: 'Kostenlos testen',
    fr: 'Essai gratuit',
    it: 'Prova gratuita',
    es: 'Prueba gratuita',
    pt: 'Teste grátis',
    nl: 'Gratis proberen',
    pl: 'Wypróbuj za darmo',
  },
  'hero.seeHow': {
    en: 'See How It Works →',
    de: 'So funktioniert\u2019s →',
    fr: 'Voir comment ça marche →',
    it: 'Scopri come funziona →',
    es: 'Ver cómo funciona →',
    pt: 'Veja como funciona →',
    nl: 'Bekijk hoe het werkt →',
    pl: 'Zobacz jak to działa →',
  },
  'hero.stat.locations': {
    en: 'Locations tracked',
    de: 'Erfasste Standorte',
    fr: 'Sites suivis',
    it: 'Sedi monitorate',
    es: 'Ubicaciones rastreadas',
    pt: 'Localidades rastreadas',
    nl: 'Locaties gevolgd',
    pl: 'Śledzonych lokalizacji',
  },
  'hero.stat.compliance': {
    en: 'Compliance rate',
    de: 'Compliance-Rate',
    fr: 'Taux de conformité',
    it: 'Tasso di conformità',
    es: 'Tasa de cumplimiento',
    pt: 'Taxa de conformidade',
    nl: 'Nalevingspercentage',
    pl: 'Wskaźnik zgodności',
  },
  'hero.stat.setup': {
    en: 'Avg setup time',
    de: 'Durchschnittl. Einrichtungszeit',
    fr: 'Temps de config. moyen',
    it: 'Tempo medio di configurazione',
    es: 'Tiempo medio de configuración',
    pt: 'Tempo médio de configuração',
    nl: 'Gem. installatietijd',
    pl: 'Śr. czas konfiguracji',
  },

  // ── Dashboard mockup ──
  'dash.compliant': {
    en: 'Compliant',
    de: 'Konform',
    fr: 'Conforme',
    it: 'Conforme',
    es: 'Conforme',
    pt: 'Conforme',
    nl: 'Conform',
    pl: 'Zgodny',
  },
  'dash.dueSoon': {
    en: 'Due Soon',
    de: 'Bald fällig',
    fr: 'Bientôt dû',
    it: 'In scadenza',
    es: 'Próximo vencimiento',
    pt: 'Vencimento próximo',
    nl: 'Binnenkort',
    pl: 'Wkrótce',
  },
  'dash.overdue': {
    en: 'Overdue',
    de: 'Überfällig',
    fr: 'En retard',
    it: 'Scaduto',
    es: 'Vencido',
    pt: 'Atrasado',
    nl: 'Achterstallig',
    pl: 'Zaległy',
  },

  // ── Trust bar ──
  'trust.label': {
    en: 'Trusted by safety teams at',
    de: 'Vertraut von Sicherheitsteams bei',
    fr: 'Utilisé par les équipes sécurité de',
    it: 'Scelto dai team sicurezza di',
    es: 'Con la confianza de equipos de seguridad en',
    pt: 'Confiado por equipes de segurança em',
    nl: 'Vertrouwd door veiligheidsteams bij',
    pl: 'Zaufany przez zespoły bezpieczeństwa w',
  },

  // ── Pain points ──
  'pain.tag': {
    en: 'Sound familiar?',
    de: 'Kommt Ihnen bekannt vor?',
    fr: 'Ça vous parle ?',
    it: 'Vi suona familiare?',
    es: '¿Le suena familiar?',
    pt: 'Soa familiar?',
    nl: 'Herkenbaar?',
    pl: 'Brzmi znajomo?',
  },
  'pain.title': {
    en: 'Fire safety compliance shouldn\u2019t feel like a fire drill',
    de: 'Brandschutz-Compliance sollte sich nicht wie eine Brandübung anfühlen',
    fr: 'La conformité incendie ne devrait pas ressembler à un exercice d\u2019évacuation',
    it: 'La conformità antincendio non dovrebbe sembrare un\u2019esercitazione',
    es: 'El cumplimiento de seguridad contra incendios no debería parecer un simulacro',
    pt: 'A conformidade contra incêndios não deveria parecer um simulacro',
    nl: 'Brandveiligheid compliance zou niet als een brandoefening moeten voelen',
    pl: 'Zgodność z ochroną przeciwpożarową nie powinna wyglądać jak alarm próbny',
  },
  'pain.sub': {
    en: 'Most teams manage compliance reactively — catching violations after they happen. FireTrack flips that entirely.',
    de: 'Die meisten Teams reagieren erst auf Verstöße, statt sie zu verhindern. FireTrack dreht das komplett um.',
    fr: 'La plupart des équipes gèrent la conformité de manière réactive. FireTrack inverse complètement cette approche.',
    it: 'La maggior parte dei team gestisce la conformità in modo reattivo. FireTrack ribalta completamente questo approccio.',
    es: 'La mayoría de equipos gestionan el cumplimiento de forma reactiva. FireTrack cambia eso por completo.',
    pt: 'A maioria das equipes gerencia conformidade de forma reativa. O FireTrack inverte isso completamente.',
    nl: 'De meeste teams beheren compliance reactief. FireTrack keert dat volledig om.',
    pl: 'Większość zespołów zarządza zgodnością reaktywnie. FireTrack całkowicie to odwraca.',
  },
  'pain.card1.title': {
    en: '\u201CWe found out about the expired extinguisher during the audit.\u201D',
    de: '\u201EWir haben den abgelaufenen Feuerlöscher erst bei der Prüfung entdeckt.\u201C',
    fr: '\u00ABNous avons découvert l\u2019extincteur expiré pendant l\u2019audit.\u00BB',
    it: '\u00ABAbbiamo scoperto l\u2019estintore scaduto durante l\u2019audit.\u00BB',
    es: '\u00ABDescubrimos el extintor caducado durante la auditoría.\u00BB',
    pt: '\u00ABDescobrimosmo o extintor vencido durante a auditoria.\u00BB',
    nl: '\u201CWe ontdekten de verlopen blusser tijdens de audit.\u201D',
    pl: '\u201EDowiedzieliśmy się o przeterminowanej gaśnicy podczas audytu.\u201D',
  },
  'pain.card1.body': {
    en: 'Inspectors don\u2019t give advance warning — but FireTrack does. Automated reminders fire 30, 14, and 7 days before every deadline so your team is never caught off guard.',
    de: 'Prüfer kündigen sich nicht an — FireTrack schon. Automatische Erinnerungen 30, 14 und 7 Tage vor jeder Frist.',
    fr: 'Les inspecteurs ne préviennent pas — FireTrack si. Rappels automatiques 30, 14 et 7 jours avant chaque échéance.',
    it: 'Gli ispettori non avvisano in anticipo — FireTrack sì. Promemoria automatici 30, 14 e 7 giorni prima di ogni scadenza.',
    es: 'Los inspectores no avisan con antelación — FireTrack sí. Recordatorios automáticos 30, 14 y 7 días antes de cada fecha límite.',
    pt: 'Inspetores não avisam com antecedência — FireTrack sim. Lembretes automáticos 30, 14 e 7 dias antes de cada prazo.',
    nl: 'Inspecteurs waarschuwen niet vooraf — FireTrack wel. Automatische herinneringen 30, 14 en 7 dagen voor elke deadline.',
    pl: 'Inspektorzy nie ostrzegają z wyprzedzeniem — FireTrack tak. Automatyczne przypomnienia 30, 14 i 7 dni przed każdym terminem.',
  },
  'pain.card2.title': {
    en: '\u201CI\u2019m managing 12 spreadsheets across 5 buildings. It\u2019s a mess.\u201D',
    de: '\u201EIch verwalte 12 Tabellen über 5 Gebäude. Ein Chaos.\u201C',
    fr: '\u00ABJe gère 12 tableurs sur 5 bâtiments. C\u2019est le chaos.\u00BB',
    it: '\u00ABGestisco 12 fogli di calcolo su 5 edifici. È un caos.\u00BB',
    es: '\u00ABGestiono 12 hojas de cálculo en 5 edificios. Es un desastre.\u00BB',
    pt: '\u00ABGerencio 12 planilhas em 5 prédios. É uma bagunça.\u00BB',
    nl: '\u201CIk beheer 12 spreadsheets over 5 gebouwen. Het is een chaos.\u201D',
    pl: '\u201EZarządzam 12 arkuszami w 5 budynkach. To bałagan.\u201D',
  },
  'pain.card2.body': {
    en: 'One dashboard. Every location. Every asset. Every inspection record \u2014 searchable, exportable, and always current. No more version-control nightmares.',
    de: 'Ein Dashboard. Jeder Standort. Jedes Gerät. Jeder Prüfbericht \u2014 durchsuchbar, exportierbar, immer aktuell.',
    fr: 'Un tableau de bord. Chaque site. Chaque équipement. Chaque rapport \u2014 consultable, exportable, toujours à jour.',
    it: 'Una dashboard. Ogni sede. Ogni dispositivo. Ogni verbale \u2014 ricercabile, esportabile, sempre aggiornato.',
    es: 'Un panel. Cada ubicación. Cada activo. Cada registro \u2014 buscable, exportable, siempre actualizado.',
    pt: 'Um painel. Cada localidade. Cada ativo. Cada registro \u2014 pesquisável, exportável, sempre atualizado.',
    nl: 'Eén dashboard. Elke locatie. Elk apparaat. Elk inspectierapport \u2014 doorzoekbaar, exporteerbaar, altijd actueel.',
    pl: 'Jeden panel. Każda lokalizacja. Każdy zasób. Każdy protokół \u2014 przeszukiwalny, eksportowalny, zawsze aktualny.',
  },
  'pain.card3.title': {
    en: '\u201CI can\u2019t tell you right now which sites are compliant.\u201D',
    de: '\u201EIch kann Ihnen jetzt nicht sagen, welche Standorte konform sind.\u201C',
    fr: '\u00ABJe ne peux pas vous dire quels sites sont conformes en ce moment.\u00BB',
    it: '\u00ABNon posso dirvi subito quali sedi sono conformi.\u00BB',
    es: '\u00ABNo puedo decirle ahora mismo qué sitios cumplen.\u00BB',
    pt: '\u00ABNão consigo dizer agora quais sites estão em conformidade.\u00BB',
    nl: '\u201CIk kan u nu niet vertellen welke locaties conform zijn.\u201D',
    pl: '\u201ENie mogę powiedzieć od ręki, które obiekty są zgodne.\u201D',
  },
  'pain.card3.body': {
    en: 'FireTrack gives you a live compliance score for every location. Red, yellow, green \u2014 you always know exactly where you stand, before the inspector does.',
    de: 'FireTrack zeigt Ihnen live den Compliance-Status jedes Standorts. Rot, gelb, grün \u2014 Sie wissen immer, wo Sie stehen.',
    fr: 'FireTrack vous donne un score de conformité en direct pour chaque site. Rouge, jaune, vert \u2014 vous savez toujours exactement où vous en êtes.',
    it: 'FireTrack fornisce un punteggio di conformità in tempo reale per ogni sede. Rosso, giallo, verde \u2014 sapete sempre esattamente a che punto siete.',
    es: 'FireTrack le da una puntuación de cumplimiento en vivo para cada ubicación. Rojo, amarillo, verde \u2014 siempre sabe exactamente dónde está.',
    pt: 'FireTrack fornece uma pontuação de conformidade ao vivo para cada localidade. Vermelho, amarelo, verde \u2014 você sempre sabe exatamente onde está.',
    nl: 'FireTrack geeft u een live compliance-score per locatie. Rood, geel, groen \u2014 u weet altijd precies waar u staat.',
    pl: 'FireTrack daje na żywo wynik zgodności dla każdej lokalizacji. Czerwony, żółty, zielony \u2014 zawsze wiesz dokładnie, jak stoisz.',
  },

  // ── Features ──
  'features.tag': {
    en: 'Features',
    de: 'Funktionen',
    fr: 'Fonctionnalités',
    it: 'Funzionalità',
    es: 'Funciones',
    pt: 'Funcionalidades',
    nl: 'Functies',
    pl: 'Funkcje',
  },
  'features.title': {
    en: 'Everything your safety team needs',
    de: 'Alles, was Ihr Sicherheitsteam braucht',
    fr: 'Tout ce dont votre équipe sécurité a besoin',
    it: 'Tutto ciò di cui il vostro team sicurezza ha bisogno',
    es: 'Todo lo que su equipo de seguridad necesita',
    pt: 'Tudo que sua equipe de segurança precisa',
    nl: 'Alles wat uw veiligheidsteam nodig heeft',
    pl: 'Wszystko, czego potrzebuje Twój zespół bezpieczeństwa',
  },
  'features.sub': {
    en: 'Purpose-built for facility managers, property teams, and HSE officers who manage fire safety in-house.',
    de: 'Speziell entwickelt für Facility Manager, Immobilienteams und HSE-Beauftragte.',
    fr: 'Conçu pour les gestionnaires d\u2019installations, les équipes immobilières et les responsables HSE.',
    it: 'Progettato per facility manager, team immobiliari e responsabili HSE.',
    es: 'Diseñado para gestores de instalaciones, equipos de propiedad y oficiales HSE.',
    pt: 'Projetado para gestores de instalações, equipes de propriedade e oficiais de HSE.',
    nl: 'Speciaal gebouwd voor facility managers, vastgoedteams en HSE-medewerkers.',
    pl: 'Zaprojektowany dla zarządców obiektów, zespołów nieruchomości i specjalistów BHP.',
  },
  'features.registry.title': {
    en: 'Unified Equipment Registry',
    de: 'Einheitliches Geräteregister',
    fr: 'Registre unifié des équipements',
    it: 'Registro unificato attrezzature',
    es: 'Registro unificado de equipos',
    pt: 'Registro unificado de equipamentos',
    nl: 'Uniform apparatenregister',
    pl: 'Zunifikowany rejestr urządzeń',
  },
  'features.registry.body': {
    en: 'Every extinguisher, suppression system, and alarm in one searchable database. Import from your existing spreadsheet or add assets manually — done in minutes.',
    de: 'Jeder Feuerlöscher, jede Löschanlage und jeder Melder in einer durchsuchbaren Datenbank. Import aus Tabellen oder manuelle Erfassung — in Minuten fertig.',
    fr: 'Chaque extincteur, système de suppression et alarme dans une base de données consultable. Importez depuis vos tableurs — prêt en quelques minutes.',
    it: 'Ogni estintore, sistema di soppressione e allarme in un database ricercabile. Importa dai fogli di calcolo — pronto in pochi minuti.',
    es: 'Cada extintor, sistema de supresión y alarma en una base de datos buscable. Importe desde su hoja de cálculo — listo en minutos.',
    pt: 'Cada extintor, sistema de supressão e alarme em um banco de dados pesquisável. Importe de sua planilha — pronto em minutos.',
    nl: 'Elke blusser, blussysteem en alarm in één doorzoekbare database. Importeer vanuit uw spreadsheet — klaar in minuten.',
    pl: 'Każda gaśnica, system tłumienia i alarm w jednej przeszukiwalnej bazie danych. Importuj z arkusza — gotowe w minuty.',
  },
  'features.reminders.title': {
    en: 'Automated Compliance Reminders',
    de: 'Automatische Compliance-Erinnerungen',
    fr: 'Rappels de conformité automatisés',
    it: 'Promemoria conformità automatici',
    es: 'Recordatorios de cumplimiento automatizados',
    pt: 'Lembretes de conformidade automatizados',
    nl: 'Automatische compliance-herinneringen',
    pl: 'Automatyczne przypomnienia o zgodności',
  },
  'features.reminders.body': {
    en: 'Set custom inspection schedules per asset type and location. FireTrack sends timely reminders to your team and tracks completion automatically.',
    de: 'Legen Sie individuelle Prüfpläne pro Gerätetyp und Standort fest. FireTrack erinnert Ihr Team automatisch.',
    fr: 'Définissez des calendriers d\u2019inspection par type d\u2019équipement et site. FireTrack envoie des rappels automatiques.',
    it: 'Impostate programmi di ispezione per tipo e sede. FireTrack invia promemoria automatici al vostro team.',
    es: 'Configure calendarios de inspección por tipo y ubicación. FireTrack envía recordatorios automáticos.',
    pt: 'Configure cronogramas de inspeção por tipo e localidade. FireTrack envia lembretes automáticos.',
    nl: 'Stel aangepaste inspectieschema\u2019s in per type en locatie. FireTrack stuurt automatische herinneringen.',
    pl: 'Ustaw harmonogramy inspekcji według typu i lokalizacji. FireTrack wysyła automatyczne przypomnienia.',
  },
  'features.reports.title': {
    en: 'Audit-Ready Reports',
    de: 'Prüfungsbereite Berichte',
    fr: 'Rapports prêts pour l\u2019audit',
    it: 'Report pronti per l\u2019audit',
    es: 'Informes listos para auditoría',
    pt: 'Relatórios prontos para auditoria',
    nl: 'Auditklare rapporten',
    pl: 'Raporty gotowe do audytu',
  },
  'features.reports.body': {
    en: 'Generate comprehensive inspection reports with one click. PDF or Excel, branded with your logo, including full history — ready for regulators the moment they arrive.',
    de: 'Erstellen Sie umfassende Prüfberichte mit einem Klick. PDF oder Excel, mit Ihrem Logo, inklusive vollständiger Historie.',
    fr: 'Générez des rapports complets en un clic. PDF ou Excel, à votre image, avec l\u2019historique complet.',
    it: 'Generate report completi con un clic. PDF o Excel, con il vostro logo, con la cronologia completa.',
    es: 'Genere informes completos con un clic. PDF o Excel, con su logo, incluyendo historial completo.',
    pt: 'Gere relatórios completos com um clique. PDF ou Excel, com sua marca, incluindo histórico completo.',
    nl: 'Genereer uitgebreide rapporten met één klik. PDF of Excel, met uw logo, inclusief volledige historie.',
    pl: 'Generuj kompleksowe raporty jednym kliknięciem. PDF lub Excel, z Twoim logo, z pełną historią.',
  },
  'features.dashboard.title': {
    en: 'Multi-Location Dashboard',
    de: 'Standortübergreifendes Dashboard',
    fr: 'Tableau de bord multi-sites',
    it: 'Dashboard multi-sede',
    es: 'Panel multi-ubicación',
    pt: 'Painel multi-localidade',
    nl: 'Multi-locatie dashboard',
    pl: 'Panel wielu lokalizacji',
  },
  'features.dashboard.body': {
    en: 'Manage fire safety across 1 to 1,000+ locations from a single screen. Drill down from portfolio view to building to individual asset in seconds.',
    de: 'Verwalten Sie Brandschutz über 1 bis 1.000+ Standorte von einem Bildschirm. Vom Portfolio bis zum einzelnen Gerät in Sekunden.',
    fr: 'Gérez la sécurité incendie de 1 à 1 000+ sites depuis un seul écran. Du portefeuille au bâtiment en quelques secondes.',
    it: 'Gestite la sicurezza antincendio da 1 a 1.000+ sedi da un\u2019unica schermata. Dal portfolio al singolo dispositivo in secondi.',
    es: 'Gestione la seguridad contra incendios en más de 1.000 ubicaciones desde una pantalla. Del portafolio al activo en segundos.',
    pt: 'Gerencie segurança contra incêndios de 1 a 1.000+ localidades em uma tela. Do portfólio ao ativo em segundos.',
    nl: 'Beheer brandveiligheid over 1 tot 1.000+ locaties vanuit één scherm. Van portfolio tot individueel apparaat in seconden.',
    pl: 'Zarządzaj ochroną przeciwpożarową od 1 do 1000+ lokalizacji z jednego ekranu. Od portfolio do urządzenia w sekundy.',
  },
  'features.mobile.title': {
    en: 'Mobile Inspections',
    de: 'Mobile Inspektionen',
    fr: 'Inspections mobiles',
    it: 'Ispezioni mobili',
    es: 'Inspecciones móviles',
    pt: 'Inspeções móveis',
    nl: 'Mobiele inspecties',
    pl: 'Inspekcje mobilne',
  },
  'features.mobile.body': {
    en: 'Field teams complete inspections on iOS or Android — even offline. Data syncs automatically the moment connectivity returns. No paper, no re-entry.',
    de: 'Teams erfassen Prüfungen auf iOS oder Android — auch offline. Daten synchronisieren sich automatisch. Kein Papier.',
    fr: 'Les équipes terrain effectuent les inspections sur iOS ou Android — même hors ligne. Synchronisation automatique.',
    it: 'I team sul campo completano le ispezioni su iOS o Android — anche offline. Sincronizzazione automatica.',
    es: 'Los equipos completan inspecciones en iOS o Android — incluso sin conexión. Sincronización automática.',
    pt: 'Equipes de campo completam inspeções no iOS ou Android — até offline. Sincronização automática.',
    nl: 'Veldteams voltooien inspecties op iOS of Android — ook offline. Automatische synchronisatie.',
    pl: 'Zespoły terenowe przeprowadzają inspekcje na iOS lub Android — nawet offline. Automatyczna synchronizacja.',
  },
  'features.score.title': {
    en: 'Real-Time Compliance Score',
    de: 'Echtzeit-Compliance-Score',
    fr: 'Score de conformité en temps réel',
    it: 'Punteggio conformità in tempo reale',
    es: 'Puntuación de cumplimiento en tiempo real',
    pt: 'Pontuação de conformidade em tempo real',
    nl: 'Realtime compliance-score',
    pl: 'Wynik zgodności w czasie rzeczywistym',
  },
  'features.score.body': {
    en: 'A live compliance score for every location, always updated. Share a link with leadership, insurers, or regulators — no preparation needed.',
    de: 'Ein Live-Compliance-Score für jeden Standort, immer aktuell. Teilen Sie einen Link mit Führungskräften oder Prüfern.',
    fr: 'Un score de conformité en direct pour chaque site, toujours à jour. Partagez un lien avec la direction ou les régulateurs.',
    it: 'Un punteggio di conformità live per ogni sede, sempre aggiornato. Condividete un link con la dirigenza o i regolatori.',
    es: 'Una puntuación de cumplimiento en vivo para cada ubicación, siempre actualizada. Comparta un enlace con la dirección.',
    pt: 'Uma pontuação de conformidade ao vivo para cada localidade, sempre atualizada. Compartilhe um link com a diretoria.',
    nl: 'Een live compliance-score per locatie, altijd actueel. Deel een link met management of inspecteurs.',
    pl: 'Wynik zgodności na żywo dla każdej lokalizacji, zawsze aktualny. Udostępnij link kierownictwu lub inspektorom.',
  },

  // ── How it works ──
  'how.tag': {
    en: 'How it works',
    de: 'So funktioniert\u2019s',
    fr: 'Comment ça marche',
    it: 'Come funziona',
    es: 'Cómo funciona',
    pt: 'Como funciona',
    nl: 'Hoe het werkt',
    pl: 'Jak to działa',
  },
  'how.title': {
    en: 'Up and running in under an hour',
    de: 'In weniger als einer Stunde startklar',
    fr: 'Opérationnel en moins d\u2019une heure',
    it: 'Operativi in meno di un\u2019ora',
    es: 'En funcionamiento en menos de una hora',
    pt: 'Funcionando em menos de uma hora',
    nl: 'Operationeel binnen een uur',
    pl: 'Działanie w mniej niż godzinę',
  },
  'how.sub': {
    en: 'No months-long onboarding. No IT project. Import your equipment, set your schedule, and stay compliant from day one.',
    de: 'Kein monatelanges Onboarding. Kein IT-Projekt. Geräte importieren, Zeitplan festlegen, ab Tag eins konform.',
    fr: 'Pas d\u2019intégration de plusieurs mois. Pas de projet IT. Importez, planifiez, conformité dès le premier jour.',
    it: 'Nessun onboarding di mesi. Nessun progetto IT. Importate, pianificate, conformi dal primo giorno.',
    es: 'Sin incorporación de meses. Sin proyecto IT. Importe, configure y cumpla desde el primer día.',
    pt: 'Sem integração de meses. Sem projeto de TI. Importe, configure e fique em conformidade desde o primeiro dia.',
    nl: 'Geen maandenlange onboarding. Geen IT-project. Importeer, plan in en wees conform vanaf dag één.',
    pl: 'Bez wielomiesięcznego wdrażania. Bez projektu IT. Importuj, zaplanuj i bądź zgodny od pierwszego dnia.',
  },
  'how.step1.title': {
    en: 'Import your equipment',
    de: 'Geräte importieren',
    fr: 'Importez vos équipements',
    it: 'Importate le attrezzature',
    es: 'Importe su equipo',
    pt: 'Importe seus equipamentos',
    nl: 'Importeer uw apparatuur',
    pl: 'Zaimportuj sprzęt',
  },
  'how.step1.body': {
    en: 'Upload your existing asset list from a spreadsheet, or add locations and equipment manually. FireTrack organizes everything by site, type, and inspection schedule.',
    de: 'Laden Sie Ihre Geräteliste aus einer Tabelle hoch oder erfassen Sie manuell. FireTrack organisiert alles nach Standort, Typ und Prüfplan.',
    fr: 'Téléchargez votre liste depuis un tableur ou ajoutez manuellement. FireTrack organise tout par site, type et calendrier.',
    it: 'Caricate la lista da un foglio di calcolo o aggiungete manualmente. FireTrack organizza tutto per sede, tipo e programma.',
    es: 'Suba su lista desde una hoja de cálculo o añada manualmente. FireTrack organiza todo por sitio, tipo y calendario.',
    pt: 'Carregue sua lista de uma planilha ou adicione manualmente. FireTrack organiza tudo por local, tipo e cronograma.',
    nl: 'Upload uw lijst vanuit een spreadsheet of voeg handmatig toe. FireTrack organiseert alles per locatie, type en schema.',
    pl: 'Wgraj listę z arkusza lub dodaj ręcznie. FireTrack organizuje wszystko wg lokalizacji, typu i harmonogramu.',
  },
  'how.step2.title': {
    en: 'Set your compliance schedule',
    de: 'Compliance-Zeitplan festlegen',
    fr: 'Définissez votre calendrier de conformité',
    it: 'Impostate il programma di conformità',
    es: 'Configure su calendario de cumplimiento',
    pt: 'Configure seu cronograma de conformidade',
    nl: 'Stel uw compliance-schema in',
    pl: 'Ustaw harmonogram zgodności',
  },
  'how.step2.body': {
    en: 'Define inspection frequencies per asset type. FireTrack sends automated reminders to your maintenance team and logs every completion with photos and notes.',
    de: 'Prüffrequenzen pro Gerätetyp definieren. FireTrack sendet automatische Erinnerungen und protokolliert jede Prüfung.',
    fr: 'Définissez les fréquences d\u2019inspection par type. FireTrack envoie des rappels automatiques et journalise chaque inspection.',
    it: 'Definite le frequenze di ispezione per tipo. FireTrack invia promemoria automatici e registra ogni completamento.',
    es: 'Defina frecuencias de inspección por tipo. FireTrack envía recordatorios automáticos y registra cada finalización.',
    pt: 'Defina frequências de inspeção por tipo. FireTrack envia lembretes automáticos e registra cada conclusão.',
    nl: 'Definieer inspectiefrequenties per type. FireTrack stuurt automatische herinneringen en logt elke afronding.',
    pl: 'Zdefiniuj częstotliwości inspekcji według typu. FireTrack wysyła automatyczne przypomnienia i rejestruje każde zakończenie.',
  },
  'how.step3.title': {
    en: 'Pass every audit',
    de: 'Jede Prüfung bestehen',
    fr: 'Réussissez chaque audit',
    it: 'Superate ogni audit',
    es: 'Pase cada auditoría',
    pt: 'Passe em cada auditoria',
    nl: 'Slaag voor elke audit',
    pl: 'Zdaj każdy audyt',
  },
  'how.step3.body': {
    en: 'When inspectors arrive, your reports are ready. Show real-time compliance status and a complete inspection history — no scrambling, no spreadsheet hunting.',
    de: 'Wenn Prüfer kommen, sind Ihre Berichte bereit. Echtzeit-Status und vollständige Historie — kein Stress.',
    fr: 'Quand les inspecteurs arrivent, vos rapports sont prêts. Statut en temps réel et historique complet — sans stress.',
    it: 'Quando arrivano gli ispettori, i vostri report sono pronti. Stato in tempo reale e cronologia completa — senza stress.',
    es: 'Cuando llegan los inspectores, sus informes están listos. Estado en tiempo real e historial completo — sin estrés.',
    pt: 'Quando inspetores chegam, seus relatórios estão prontos. Status em tempo real e histórico completo — sem estresse.',
    nl: 'Wanneer inspecteurs komen, zijn uw rapporten klaar. Realtime status en complete historie — geen stress.',
    pl: 'Gdy przyjdą inspektorzy, raporty są gotowe. Status w czasie rzeczywistym i pełna historia — bez stresu.',
  },

  // ── Comparison ──
  'compare.tag': {
    en: 'Why FireTrack',
    de: 'Warum FireTrack',
    fr: 'Pourquoi FireTrack',
    it: 'Perché FireTrack',
    es: 'Por qué FireTrack',
    pt: 'Por que FireTrack',
    nl: 'Waarom FireTrack',
    pl: 'Dlaczego FireTrack',
  },
  'compare.title': {
    en: 'Finally, software built for your side of the job',
    de: 'Endlich Software, die für Ihre Seite der Arbeit gebaut wurde',
    fr: 'Enfin, un logiciel conçu pour votre côté du métier',
    it: 'Finalmente, un software pensato per la vostra parte del lavoro',
    es: 'Por fin, software diseñado para su lado del trabajo',
    pt: 'Finalmente, software feito para o seu lado do trabalho',
    nl: 'Eindelijk software gebouwd voor uw kant van het werk',
    pl: 'Wreszcie oprogramowanie stworzone dla Twojej strony pracy',
  },
  'compare.sub': {
    en: 'Spreadsheets break at scale. Contractor software is built for the people who service you — not for your in-house team.',
    de: 'Tabellen skalieren nicht. Software für Dienstleister ist für Dienstleister — nicht für Ihr internes Team.',
    fr: 'Les tableurs ne tiennent pas à grande échelle. Les logiciels prestataires sont faits pour les prestataires — pas pour votre équipe.',
    it: 'I fogli di calcolo non scalano. Il software per fornitori è fatto per i fornitori — non per il vostro team.',
    es: 'Las hojas de cálculo no escalan. El software de contratistas es para contratistas — no para su equipo.',
    pt: 'Planilhas não escalam. Software de terceiros é feito para terceiros — não para sua equipe.',
    nl: 'Spreadsheets schalen niet. Software voor aannemers is voor aannemers — niet voor uw team.',
    pl: 'Arkusze nie skalują się. Oprogramowanie dla wykonawców jest dla wykonawców — nie dla Twojego zespołu.',
  },
  'compare.col.firetrack': {
    en: 'FireTrack',
    de: 'FireTrack',
    fr: 'FireTrack',
    it: 'FireTrack',
    es: 'FireTrack',
    pt: 'FireTrack',
    nl: 'FireTrack',
    pl: 'FireTrack',
  },
  'compare.col.spreadsheets': {
    en: 'Spreadsheets',
    de: 'Tabellen',
    fr: 'Tableurs',
    it: 'Fogli di calcolo',
    es: 'Hojas de cálculo',
    pt: 'Planilhas',
    nl: 'Spreadsheets',
    pl: 'Arkusze',
  },
  'compare.col.contractor': {
    en: 'Contractor Software',
    de: 'Dienstleister-Software',
    fr: 'Logiciel prestataire',
    it: 'Software fornitori',
    es: 'Software contratista',
    pt: 'Software terceiros',
    nl: 'Aannemer-software',
    pl: 'Oprogramowanie wykonawcy',
  },
  'compare.row.owners': {
    en: 'Built for building owners & facility teams',
    de: 'Für Gebäudeeigentümer & Facility-Teams',
    fr: 'Conçu pour propriétaires & équipes installations',
    it: 'Per proprietari e team facility',
    es: 'Para propietarios y equipos de instalaciones',
    pt: 'Para proprietários e equipes de instalações',
    nl: 'Voor gebouweigenaren & facilityteams',
    pl: 'Dla właścicieli budynków i zespołów obiektowych',
  },
  'compare.row.dashboard': {
    en: 'Real-time compliance dashboard',
    de: 'Echtzeit-Compliance-Dashboard',
    fr: 'Tableau de bord conformité en temps réel',
    it: 'Dashboard conformità in tempo reale',
    es: 'Panel de cumplimiento en tiempo real',
    pt: 'Painel de conformidade em tempo real',
    nl: 'Realtime compliance-dashboard',
    pl: 'Panel zgodności w czasie rzeczywistym',
  },
  'compare.row.reminders': {
    en: 'Automated inspection reminders',
    de: 'Automatische Prüf-Erinnerungen',
    fr: 'Rappels d\u2019inspection automatisés',
    it: 'Promemoria ispezione automatici',
    es: 'Recordatorios de inspección automatizados',
    pt: 'Lembretes de inspeção automatizados',
    nl: 'Automatische inspectieherinneringen',
    pl: 'Automatyczne przypomnienia inspekcji',
  },
  'compare.row.multiLocation': {
    en: 'Multi-location management',
    de: 'Standortübergreifende Verwaltung',
    fr: 'Gestion multi-sites',
    it: 'Gestione multi-sede',
    es: 'Gestión multi-ubicación',
    pt: 'Gestão multi-localidade',
    nl: 'Multi-locatiebeheer',
    pl: 'Zarządzanie wieloma lokalizacjami',
  },
  'compare.row.reports': {
    en: 'Instant audit-ready reports',
    de: 'Sofort prüfungsbereite Berichte',
    fr: 'Rapports d\u2019audit instantanés',
    it: 'Report audit istantanei',
    es: 'Informes de auditoría instantáneos',
    pt: 'Relatórios de auditoria instantâneos',
    nl: 'Direct auditklare rapporten',
    pl: 'Natychmiastowe raporty audytowe',
  },
  'compare.row.mobile': {
    en: 'Mobile offline inspections',
    de: 'Mobile Offline-Inspektionen',
    fr: 'Inspections mobiles hors ligne',
    it: 'Ispezioni mobili offline',
    es: 'Inspecciones móviles offline',
    pt: 'Inspeções móveis offline',
    nl: 'Mobiele offline-inspecties',
    pl: 'Mobilne inspekcje offline',
  },
  'compare.row.setup': {
    en: 'Setup in under an hour',
    de: 'Einrichtung in unter einer Stunde',
    fr: 'Configuration en moins d\u2019une heure',
    it: 'Configurazione in meno di un\u2019ora',
    es: 'Configuración en menos de una hora',
    pt: 'Configuração em menos de uma hora',
    nl: 'Installatie binnen een uur',
    pl: 'Konfiguracja w mniej niż godzinę',
  },
  'compare.row.pricing': {
    en: 'Flat pricing — no per-user fees',
    de: 'Pauschale Preise — keine Gebühren pro Benutzer',
    fr: 'Tarif forfaitaire — pas de frais par utilisateur',
    it: 'Prezzo fisso — nessun costo per utente',
    es: 'Precio fijo — sin tarifas por usuario',
    pt: 'Preço fixo — sem taxas por usuário',
    nl: 'Vast tarief — geen kosten per gebruiker',
    pl: 'Stała cena — bez opłat za użytkownika',
  },

  // ── Testimonials ──
  'testimonials.tag': {
    en: 'Customer Stories',
    de: 'Kundenstimmen',
    fr: 'Témoignages clients',
    it: 'Storie dei clienti',
    es: 'Historias de clientes',
    pt: 'Histórias de clientes',
    nl: 'Klantverhalen',
    pl: 'Historie klientów',
  },
  'testimonials.title': {
    en: 'Trusted by teams who\u2019ve been burned before',
    de: 'Vertraut von Teams, die sich schon die Finger verbrannt haben',
    fr: 'Choisi par des équipes qui ont déjà été échaudées',
    it: 'Scelto da team che ci sono già passati',
    es: 'Confiado por equipos que ya se quemaron antes',
    pt: 'Confiado por equipes que já se queimaram antes',
    nl: 'Vertrouwd door teams die zich al eerder gebrand hebben',
    pl: 'Zaufany przez zespoły, które już się sparzyły',
  },

  // ── Pricing ──
  'pricing.tag': {
    en: 'Pricing',
    de: 'Preise',
    fr: 'Tarifs',
    it: 'Prezzi',
    es: 'Precios',
    pt: 'Preços',
    nl: 'Prijzen',
    pl: 'Cennik',
  },
  'pricing.title': {
    en: 'Simple pricing. No surprises.',
    de: 'Einfache Preise. Keine Überraschungen.',
    fr: 'Tarifs simples. Pas de surprises.',
    it: 'Prezzi semplici. Nessuna sorpresa.',
    es: 'Precios simples. Sin sorpresas.',
    pt: 'Preços simples. Sem surpresas.',
    nl: 'Eenvoudige prijzen. Geen verrassingen.',
    pl: 'Proste ceny. Bez niespodzianek.',
  },
  'pricing.sub': {
    en: 'Flat monthly fees — no per-user pricing that penalizes you for growing your team. Cancel any time.',
    de: 'Monatliche Pauschale — keine Preise pro Benutzer. Jederzeit kündbar.',
    fr: 'Forfait mensuel — pas de tarification par utilisateur. Résiliez quand vous voulez.',
    it: 'Canone mensile fisso — nessun prezzo per utente. Cancellate quando volete.',
    es: 'Cuotas mensuales fijas — sin precios por usuario. Cancele cuando quiera.',
    pt: 'Taxas mensais fixas — sem preço por usuário. Cancele quando quiser.',
    nl: 'Vast maandelijks tarief — geen prijzen per gebruiker. Op elk moment opzegbaar.',
    pl: 'Stała opłata miesięczna — bez cen za użytkownika. Anuluj w dowolnym momencie.',
  },
  'pricing.mostPopular': {
    en: 'Most Popular',
    de: 'Am beliebtesten',
    fr: 'Le plus populaire',
    it: 'Più popolare',
    es: 'Más popular',
    pt: 'Mais popular',
    nl: 'Meest populair',
    pl: 'Najpopularniejszy',
  },
  'pricing.perMonth': {
    en: '/month',
    de: '/Monat',
    fr: '/mois',
    it: '/mese',
    es: '/mes',
    pt: '/mês',
    nl: '/maand',
    pl: '/miesiąc',
  },
  'pricing.starter': {
    en: 'Starter',
    de: 'Starter',
    fr: 'Starter',
    it: 'Starter',
    es: 'Starter',
    pt: 'Starter',
    nl: 'Starter',
    pl: 'Starter',
  },
  'pricing.starter.desc': {
    en: 'For small teams managing a handful of buildings who need to get off spreadsheets fast.',
    de: 'Für kleine Teams, die schnell von Tabellen wegkommen wollen.',
    fr: 'Pour les petites équipes qui veulent quitter les tableurs rapidement.',
    it: 'Per piccoli team che vogliono abbandonare i fogli di calcolo.',
    es: 'Para equipos pequeños que necesitan dejar las hojas de cálculo rápido.',
    pt: 'Para equipes pequenas que precisam abandonar planilhas rápido.',
    nl: 'Voor kleine teams die snel af willen van spreadsheets.',
    pl: 'Dla małych zespołów, które chcą szybko porzucić arkusze.',
  },
  'pricing.starter.f1': {
    en: 'Up to 5 locations',
    de: 'Bis zu 5 Standorte',
    fr: 'Jusqu\u2019à 5 sites',
    it: 'Fino a 5 sedi',
    es: 'Hasta 5 ubicaciones',
    pt: 'Até 5 localidades',
    nl: 'Tot 5 locaties',
    pl: 'Do 5 lokalizacji',
  },
  'pricing.starter.f2': {
    en: 'Up to 250 assets',
    de: 'Bis zu 250 Geräte',
    fr: 'Jusqu\u2019à 250 équipements',
    it: 'Fino a 250 dispositivi',
    es: 'Hasta 250 activos',
    pt: 'Até 250 ativos',
    nl: 'Tot 250 apparaten',
    pl: 'Do 250 zasobów',
  },
  'pricing.starter.f3': {
    en: 'Automated inspection reminders',
    de: 'Automatische Prüf-Erinnerungen',
    fr: 'Rappels d\u2019inspection automatisés',
    it: 'Promemoria ispezione automatici',
    es: 'Recordatorios de inspección automatizados',
    pt: 'Lembretes de inspeção automatizados',
    nl: 'Automatische inspectieherinneringen',
    pl: 'Automatyczne przypomnienia inspekcji',
  },
  'pricing.starter.f4': {
    en: 'PDF compliance reports',
    de: 'PDF-Compliance-Berichte',
    fr: 'Rapports de conformité PDF',
    it: 'Report conformità PDF',
    es: 'Informes de cumplimiento PDF',
    pt: 'Relatórios de conformidade PDF',
    nl: 'PDF compliance-rapporten',
    pl: 'Raporty zgodności PDF',
  },
  'pricing.starter.f5': {
    en: 'Mobile app (iOS & Android)',
    de: 'Mobile App (iOS & Android)',
    fr: 'Application mobile (iOS & Android)',
    it: 'App mobile (iOS & Android)',
    es: 'App móvil (iOS & Android)',
    pt: 'App móvel (iOS & Android)',
    nl: 'Mobiele app (iOS & Android)',
    pl: 'Aplikacja mobilna (iOS & Android)',
  },
  'pricing.starter.f6': {
    en: 'Email support',
    de: 'E-Mail-Support',
    fr: 'Support par e-mail',
    it: 'Supporto via e-mail',
    es: 'Soporte por email',
    pt: 'Suporte por e-mail',
    nl: 'E-mailondersteuning',
    pl: 'Wsparcie e-mail',
  },
  'pricing.growth': {
    en: 'Growth',
    de: 'Growth',
    fr: 'Growth',
    it: 'Growth',
    es: 'Growth',
    pt: 'Growth',
    nl: 'Growth',
    pl: 'Growth',
  },
  'pricing.growth.desc': {
    en: 'For growing teams managing multiple sites, complex schedules, and regular audits.',
    de: 'Für wachsende Teams mit mehreren Standorten und regelmäßigen Prüfungen.',
    fr: 'Pour les équipes en croissance avec plusieurs sites et des audits réguliers.',
    it: 'Per team in crescita con più sedi e audit regolari.',
    es: 'Para equipos en crecimiento con múltiples sitios y auditorías regulares.',
    pt: 'Para equipes em crescimento com múltiplos locais e auditorias regulares.',
    nl: 'Voor groeiende teams met meerdere locaties en regelmatige audits.',
    pl: 'Dla rosnących zespołów z wieloma lokalizacjami i regularnymi audytami.',
  },
  'pricing.growth.f1': {
    en: 'Up to 30 locations',
    de: 'Bis zu 30 Standorte',
    fr: 'Jusqu\u2019à 30 sites',
    it: 'Fino a 30 sedi',
    es: 'Hasta 30 ubicaciones',
    pt: 'Até 30 localidades',
    nl: 'Tot 30 locaties',
    pl: 'Do 30 lokalizacji',
  },
  'pricing.growth.f2': {
    en: 'Unlimited assets',
    de: 'Unbegrenzte Geräte',
    fr: 'Équipements illimités',
    it: 'Dispositivi illimitati',
    es: 'Activos ilimitados',
    pt: 'Ativos ilimitados',
    nl: 'Onbeperkt apparaten',
    pl: 'Nieograniczone zasoby',
  },
  'pricing.growth.f3': {
    en: 'Everything in Starter',
    de: 'Alles aus Starter',
    fr: 'Tout du Starter',
    it: 'Tutto dello Starter',
    es: 'Todo del Starter',
    pt: 'Tudo do Starter',
    nl: 'Alles uit Starter',
    pl: 'Wszystko ze Starter',
  },
  'pricing.growth.f4': {
    en: 'Multi-location dashboard',
    de: 'Standortübergreifendes Dashboard',
    fr: 'Tableau de bord multi-sites',
    it: 'Dashboard multi-sede',
    es: 'Panel multi-ubicación',
    pt: 'Painel multi-localidade',
    nl: 'Multi-locatie dashboard',
    pl: 'Panel wielu lokalizacji',
  },
  'pricing.growth.f5': {
    en: 'Custom inspection forms',
    de: 'Individuelle Prüfformulare',
    fr: 'Formulaires d\u2019inspection personnalisés',
    it: 'Moduli di ispezione personalizzati',
    es: 'Formularios de inspección personalizados',
    pt: 'Formulários de inspeção personalizados',
    nl: 'Aangepaste inspectieformulieren',
    pl: 'Niestandardowe formularze inspekcji',
  },
  'pricing.growth.f6': {
    en: 'Data export (CSV / Excel)',
    de: 'Datenexport (CSV / Excel)',
    fr: 'Export de données (CSV / Excel)',
    it: 'Esportazione dati (CSV / Excel)',
    es: 'Exportación de datos (CSV / Excel)',
    pt: 'Exportação de dados (CSV / Excel)',
    nl: 'Data-export (CSV / Excel)',
    pl: 'Eksport danych (CSV / Excel)',
  },
  'pricing.growth.f7': {
    en: 'Priority support',
    de: 'Prioritäts-Support',
    fr: 'Support prioritaire',
    it: 'Supporto prioritario',
    es: 'Soporte prioritario',
    pt: 'Suporte prioritário',
    nl: 'Prioriteitsondersteuning',
    pl: 'Priorytetowe wsparcie',
  },
  'pricing.enterprise': {
    en: 'Enterprise',
    de: 'Enterprise',
    fr: 'Enterprise',
    it: 'Enterprise',
    es: 'Enterprise',
    pt: 'Enterprise',
    nl: 'Enterprise',
    pl: 'Enterprise',
  },
  'pricing.enterprise.desc': {
    en: 'For organizations managing dozens of sites with advanced compliance and integration needs.',
    de: 'Für Organisationen mit Dutzenden Standorten und erweiterten Compliance-Anforderungen.',
    fr: 'Pour les organisations gérant des dizaines de sites avec des besoins avancés.',
    it: 'Per organizzazioni con decine di sedi e necessità avanzate di conformità.',
    es: 'Para organizaciones con docenas de sitios y necesidades avanzadas de cumplimiento.',
    pt: 'Para organizações com dezenas de locais e necessidades avançadas de conformidade.',
    nl: 'Voor organisaties met tientallen locaties en geavanceerde compliance-behoeften.',
    pl: 'Dla organizacji z dziesiątkami lokalizacji i zaawansowanymi wymaganiami zgodności.',
  },
  'pricing.enterprise.f1': {
    en: 'Unlimited locations & assets',
    de: 'Unbegrenzte Standorte & Geräte',
    fr: 'Sites & équipements illimités',
    it: 'Sedi & dispositivi illimitati',
    es: 'Ubicaciones & activos ilimitados',
    pt: 'Localidades & ativos ilimitados',
    nl: 'Onbeperkt locaties & apparaten',
    pl: 'Nieograniczone lokalizacje i zasoby',
  },
  'pricing.enterprise.f2': {
    en: 'Everything in Growth',
    de: 'Alles aus Growth',
    fr: 'Tout du Growth',
    it: 'Tutto del Growth',
    es: 'Todo del Growth',
    pt: 'Tudo do Growth',
    nl: 'Alles uit Growth',
    pl: 'Wszystko z Growth',
  },
  'pricing.enterprise.f3': {
    en: 'SSO / SAML integration',
    de: 'SSO / SAML Integration',
    fr: 'Intégration SSO / SAML',
    it: 'Integrazione SSO / SAML',
    es: 'Integración SSO / SAML',
    pt: 'Integração SSO / SAML',
    nl: 'SSO / SAML integratie',
    pl: 'Integracja SSO / SAML',
  },
  'pricing.enterprise.f4': {
    en: 'REST API access',
    de: 'REST-API-Zugang',
    fr: 'Accès API REST',
    it: 'Accesso API REST',
    es: 'Acceso API REST',
    pt: 'Acesso API REST',
    nl: 'REST API-toegang',
    pl: 'Dostęp do API REST',
  },
  'pricing.enterprise.f5': {
    en: 'Dedicated account manager',
    de: 'Dedizierter Account Manager',
    fr: 'Responsable de compte dédié',
    it: 'Account manager dedicato',
    es: 'Gestor de cuenta dedicado',
    pt: 'Gerente de conta dedicado',
    nl: 'Dedicated accountmanager',
    pl: 'Dedykowany opiekun konta',
  },
  'pricing.enterprise.f6': {
    en: 'Custom SLA',
    de: 'Individuelles SLA',
    fr: 'SLA personnalisé',
    it: 'SLA personalizzato',
    es: 'SLA personalizado',
    pt: 'SLA personalizado',
    nl: 'Aangepast SLA',
    pl: 'Niestandardowe SLA',
  },
  'pricing.enterprise.f7': {
    en: 'White-label reports',
    de: 'White-Label-Berichte',
    fr: 'Rapports marque blanche',
    it: 'Report white-label',
    es: 'Informes marca blanca',
    pt: 'Relatórios marca branca',
    nl: 'White-label rapporten',
    pl: 'Raporty white-label',
  },
  'pricing.startTrial': {
    en: 'Start Free Trial',
    de: 'Kostenlos testen',
    fr: 'Essai gratuit',
    it: 'Prova gratuita',
    es: 'Prueba gratuita',
    pt: 'Teste grátis',
    nl: 'Gratis proberen',
    pl: 'Wypróbuj za darmo',
  },
  'pricing.contactSales': {
    en: 'Contact Sales',
    de: 'Vertrieb kontaktieren',
    fr: 'Contacter les ventes',
    it: 'Contatta le vendite',
    es: 'Contactar ventas',
    pt: 'Contatar vendas',
    nl: 'Contact verkoop',
    pl: 'Skontaktuj się ze sprzedażą',
  },
  'pricing.note': {
    en: 'All plans include a 14-day free trial. No credit card required.',
    de: 'Alle Pläne mit 14 Tagen kostenloser Testphase. Keine Kreditkarte nötig.',
    fr: 'Tous les plans incluent 14 jours d\u2019essai gratuit. Pas de carte bancaire requise.',
    it: 'Tutti i piani includono 14 giorni di prova gratuita. Nessuna carta di credito richiesta.',
    es: 'Todos los planes incluyen 14 días de prueba gratis. No se requiere tarjeta de crédito.',
    pt: 'Todos os planos incluem 14 dias de teste grátis. Sem cartão de crédito.',
    nl: 'Alle plannen bevatten 14 dagen gratis proefperiode. Geen creditcard nodig.',
    pl: 'Wszystkie plany obejmują 14-dniowy bezpłatny okres próbny. Bez karty kredytowej.',
  },
  'pricing.custom': {
    en: 'Custom',
    de: 'Individuell',
    fr: 'Sur mesure',
    it: 'Personalizzato',
    es: 'Personalizado',
    pt: 'Personalizado',
    nl: 'Op maat',
    pl: 'Indywidualny',
  },

  // ── FAQ ──
  'faq.tag': {
    en: 'FAQ',
    de: 'FAQ',
    fr: 'FAQ',
    it: 'FAQ',
    es: 'FAQ',
    pt: 'FAQ',
    nl: 'FAQ',
    pl: 'FAQ',
  },
  'faq.title': {
    en: 'Common questions',
    de: 'Häufige Fragen',
    fr: 'Questions fréquentes',
    it: 'Domande frequenti',
    es: 'Preguntas frecuentes',
    pt: 'Perguntas frequentes',
    nl: 'Veelgestelde vragen',
    pl: 'Częste pytania',
  },
  'faq.q1': {
    en: 'Is FireTrack for fire protection contractors or building owners?',
    de: 'Ist FireTrack für Brandschutzdienstleister oder Gebäudeeigentümer?',
    fr: 'FireTrack est-il pour les entreprises de protection incendie ou les propriétaires ?',
    it: 'FireTrack è per imprese antincendio o proprietari di edifici?',
    es: '¿FireTrack es para contratistas de protección contra incendios o propietarios?',
    pt: 'O FireTrack é para empresas de proteção contra incêndios ou proprietários?',
    nl: 'Is FireTrack voor brandbeveiliging aannemers of gebouweigenaren?',
    pl: 'Czy FireTrack jest dla firm ochrony przeciwpożarowej czy właścicieli budynków?',
  },
  'faq.a1': {
    en: 'FireTrack is built for building owners, facility managers, and HSE teams — the people responsible for maintaining fire safety compliance on their own properties. If you\u2019re a fire protection contractor looking for scheduling and invoicing software, other tools are better suited for that work.',
    de: 'FireTrack ist für Gebäudeeigentümer, Facility Manager und HSE-Teams — die Verantwortlichen für Brandschutz-Compliance auf ihren eigenen Immobilien.',
    fr: 'FireTrack est conçu pour les propriétaires, gestionnaires d\u2019installations et équipes HSE — ceux qui assurent la conformité incendie sur leurs propres biens.',
    it: 'FireTrack è per proprietari, facility manager e team HSE — chi è responsabile della conformità antincendio nelle proprie strutture.',
    es: 'FireTrack está diseñado para propietarios, gestores de instalaciones y equipos HSE — los responsables del cumplimiento en sus propiedades.',
    pt: 'FireTrack é para proprietários, gestores de instalações e equipes HSE — os responsáveis pela conformidade em suas propriedades.',
    nl: 'FireTrack is voor gebouweigenaren, facility managers en HSE-teams — verantwoordelijk voor brandveiligheid op hun eigen panden.',
    pl: 'FireTrack jest dla właścicieli budynków, zarządców obiektów i zespołów BHP — odpowiedzialnych za zgodność na swoich nieruchomościach.',
  },
  'faq.q2': {
    en: 'How long does setup take?',
    de: 'Wie lange dauert die Einrichtung?',
    fr: 'Combien de temps prend la configuration ?',
    it: 'Quanto tempo richiede la configurazione?',
    es: '¿Cuánto tiempo lleva la configuración?',
    pt: 'Quanto tempo leva a configuração?',
    nl: 'Hoe lang duurt de installatie?',
    pl: 'Ile czasu zajmuje konfiguracja?',
  },
  'faq.a2': {
    en: 'Most teams are fully operational in under an hour. Import your existing equipment list from a spreadsheet and we\u2019ll walk you through setting up inspection schedules. No IT involvement, no months-long onboarding.',
    de: 'Die meisten Teams sind in unter einer Stunde startklar. Importieren Sie Ihre Geräteliste und wir führen Sie durch die Einrichtung.',
    fr: 'La plupart des équipes sont opérationnelles en moins d\u2019une heure. Importez votre liste et nous vous guidons.',
    it: 'La maggior parte dei team è operativa in meno di un\u2019ora. Importate la vostra lista e vi guidiamo.',
    es: 'La mayoría de equipos están operativos en menos de una hora. Importe su lista y le guiamos.',
    pt: 'A maioria das equipes está operacional em menos de uma hora. Importe sua lista e nós guiamos você.',
    nl: 'De meeste teams zijn binnen een uur operationeel. Importeer uw lijst en wij begeleiden u.',
    pl: 'Większość zespołów jest gotowa w mniej niż godzinę. Zaimportuj listę, a my Cię przeprowadzimy.',
  },
  'faq.q3': {
    en: 'Does FireTrack work offline?',
    de: 'Funktioniert FireTrack offline?',
    fr: 'FireTrack fonctionne-t-il hors ligne ?',
    it: 'FireTrack funziona offline?',
    es: '¿FireTrack funciona offline?',
    pt: 'O FireTrack funciona offline?',
    nl: 'Werkt FireTrack offline?',
    pl: 'Czy FireTrack działa offline?',
  },
  'faq.a3': {
    en: 'Yes. The mobile app works fully offline — your team can complete inspections in basements, plant rooms, or anywhere without connectivity. All data syncs automatically when the connection is restored.',
    de: 'Ja. Die mobile App funktioniert vollständig offline. Alle Daten synchronisieren sich automatisch bei Verbindung.',
    fr: 'Oui. L\u2019app mobile fonctionne entièrement hors ligne. Toutes les données se synchronisent automatiquement.',
    it: 'Sì. L\u2019app mobile funziona completamente offline. Tutti i dati si sincronizzano automaticamente.',
    es: 'Sí. La app móvil funciona completamente offline. Todos los datos se sincronizan automáticamente.',
    pt: 'Sim. O app móvel funciona totalmente offline. Todos os dados sincronizam automaticamente.',
    nl: 'Ja. De mobiele app werkt volledig offline. Alle data synchroniseert automatisch.',
    pl: 'Tak. Aplikacja mobilna działa w pełni offline. Wszystkie dane synchronizują się automatycznie.',
  },
  'faq.q4': {
    en: 'Can I generate reports for insurance audits or regulatory inspections?',
    de: 'Kann ich Berichte für Versicherungsprüfungen oder behördliche Inspektionen erstellen?',
    fr: 'Puis-je générer des rapports pour les audits d\u2019assurance ou les inspections réglementaires ?',
    it: 'Posso generare report per audit assicurativi o ispezioni normative?',
    es: '¿Puedo generar informes para auditorías de seguros o inspecciones regulatorias?',
    pt: 'Posso gerar relatórios para auditorias de seguros ou inspeções regulatórias?',
    nl: 'Kan ik rapporten genereren voor verzekeringsaudits of wettelijke inspecties?',
    pl: 'Czy mogę generować raporty do audytów ubezpieczeniowych lub inspekcji regulacyjnych?',
  },
  'faq.a4': {
    en: 'One click generates a comprehensive compliance report for any single location or your entire portfolio. Reports include full inspection history, asset details, deficiency tracking, and your current compliance score — ready to hand to any regulator or insurer.',
    de: 'Ein Klick erstellt einen umfassenden Compliance-Bericht für jeden Standort oder Ihr gesamtes Portfolio.',
    fr: 'Un clic génère un rapport complet pour un site ou votre portefeuille entier.',
    it: 'Un clic genera un report completo per ogni sede o l\u2019intero portfolio.',
    es: 'Un clic genera un informe completo para cualquier ubicación o su cartera completa.',
    pt: 'Um clique gera um relatório completo para qualquer localidade ou seu portfólio inteiro.',
    nl: 'Eén klik genereert een volledig rapport voor elke locatie of uw hele portfolio.',
    pl: 'Jedno kliknięcie generuje kompleksowy raport dla dowolnej lokalizacji lub całego portfolio.',
  },
  'faq.q5': {
    en: 'What happens if we have more assets than our plan allows?',
    de: 'Was passiert, wenn wir mehr Geräte haben als unser Plan erlaubt?',
    fr: 'Que se passe-t-il si nous avons plus d\u2019équipements que notre plan le permet ?',
    it: 'Cosa succede se abbiamo più dispositivi di quelli previsti dal piano?',
    es: '¿Qué pasa si tenemos más activos de los que permite nuestro plan?',
    pt: 'O que acontece se tivermos mais ativos do que nosso plano permite?',
    nl: 'Wat als we meer apparaten hebben dan ons plan toestaat?',
    pl: 'Co się stanie, jeśli mamy więcej zasobów niż pozwala nasz plan?',
  },
  'faq.a5': {
    en: 'We\u2019ll notify you well before you hit your limit and make upgrading straightforward. We never cut off access to your data mid-cycle. If you\u2019re unsure which plan fits, start on Starter — you can upgrade at any time with no data migration needed.',
    de: 'Wir benachrichtigen Sie rechtzeitig und machen das Upgrade einfach. Ihr Datenzugang wird nie unterbrochen.',
    fr: 'Nous vous prévenons avant d\u2019atteindre la limite et simplifions la mise à niveau. Votre accès n\u2019est jamais coupé.',
    it: 'Vi avvisiamo prima di raggiungere il limite e semplifichiamo l\u2019upgrade. L\u2019accesso ai dati non viene mai interrotto.',
    es: 'Le notificamos antes de alcanzar el límite y facilitamos la actualización. Su acceso nunca se interrumpe.',
    pt: 'Notificamos antes de atingir o limite e facilitamos o upgrade. Seu acesso nunca é interrompido.',
    nl: 'We waarschuwen u ruim voor de limiet en maken upgraden eenvoudig. Uw toegang wordt nooit onderbroken.',
    pl: 'Powiadomimy Cię przed osiągnięciem limitu i ułatwimy upgrade. Dostęp do danych nigdy nie jest przerywany.',
  },

  // ── Final CTA ──
  'cta.title': {
    en: 'Ready to pass your next audit with confidence?',
    de: 'Bereit, Ihre nächste Prüfung souverän zu bestehen?',
    fr: 'Prêt à réussir votre prochain audit en toute confiance ?',
    it: 'Pronti a superare il prossimo audit con sicurezza?',
    es: '¿Listo para pasar su próxima auditoría con confianza?',
    pt: 'Pronto para passar sua próxima auditoria com confiança?',
    nl: 'Klaar om uw volgende audit met vertrouwen te doorstaan?',
    pl: 'Gotowy, by pewnie przejść następny audyt?',
  },
  'cta.sub': {
    en: 'Join 2,400+ locations already using FireTrack. Start your 14-day free trial — no credit card required.',
    de: 'Schließen Sie sich 2.400+ Standorten an. Starten Sie Ihre 14-tägige Testphase — keine Kreditkarte nötig.',
    fr: 'Rejoignez plus de 2 400 sites. Commencez votre essai gratuit de 14 jours — sans carte bancaire.',
    it: 'Unitevi a oltre 2.400 sedi. Iniziate la prova gratuita di 14 giorni — senza carta di credito.',
    es: 'Únase a más de 2.400 ubicaciones. Empiece su prueba gratuita de 14 días — sin tarjeta de crédito.',
    pt: 'Junte-se a mais de 2.400 localidades. Comece seu teste grátis de 14 dias — sem cartão de crédito.',
    nl: 'Sluit u aan bij 2.400+ locaties. Start uw 14-daagse proefperiode — geen creditcard nodig.',
    pl: 'Dołącz do ponad 2400 lokalizacji. Rozpocznij 14-dniowy bezpłatny okres próbny — bez karty kredytowej.',
  },
  'cta.bookDemo': {
    en: 'Book a Demo',
    de: 'Demo buchen',
    fr: 'Réserver une démo',
    it: 'Prenota una demo',
    es: 'Reservar una demo',
    pt: 'Agendar uma demo',
    nl: 'Demo boeken',
    pl: 'Zarezerwuj demo',
  },

  // ── Footer ──
  'footer.tagline': {
    en: 'The compliance platform for facility managers who can\u2019t afford surprises.',
    de: 'Die Compliance-Plattform für Facility Manager, die sich keine Überraschungen leisten können.',
    fr: 'La plateforme de conformité pour les gestionnaires qui ne peuvent pas se permettre de surprises.',
    it: 'La piattaforma di conformità per facility manager che non possono permettersi sorprese.',
    es: 'La plataforma de cumplimiento para gestores que no pueden permitirse sorpresas.',
    pt: 'A plataforma de conformidade para gestores que não podem se dar ao luxo de surpresas.',
    nl: 'Het compliance-platform voor facility managers die zich geen verrassingen kunnen veroorloven.',
    pl: 'Platforma zgodności dla zarządców, którzy nie mogą sobie pozwolić na niespodzianki.',
  },
  'footer.product': {
    en: 'Product',
    de: 'Produkt',
    fr: 'Produit',
    it: 'Prodotto',
    es: 'Producto',
    pt: 'Produto',
    nl: 'Product',
    pl: 'Produkt',
  },
  'footer.resources': {
    en: 'Resources',
    de: 'Ressourcen',
    fr: 'Ressources',
    it: 'Risorse',
    es: 'Recursos',
    pt: 'Recursos',
    nl: 'Hulpbronnen',
    pl: 'Zasoby',
  },
  'footer.company': {
    en: 'Company',
    de: 'Unternehmen',
    fr: 'Entreprise',
    it: 'Azienda',
    es: 'Empresa',
    pt: 'Empresa',
    nl: 'Bedrijf',
    pl: 'Firma',
  },
  'footer.legal': {
    en: 'Legal',
    de: 'Rechtliches',
    fr: 'Mentions légales',
    it: 'Legale',
    es: 'Legal',
    pt: 'Legal',
    nl: 'Juridisch',
    pl: 'Prawne',
  },
  'footer.copyright': {
    en: '© 2026 FireTrack. All rights reserved.',
    de: '© 2026 FireTrack. Alle Rechte vorbehalten.',
    fr: '© 2026 FireTrack. Tous droits réservés.',
    it: '© 2026 FireTrack. Tutti i diritti riservati.',
    es: '© 2026 FireTrack. Todos los derechos reservados.',
    pt: '© 2026 FireTrack. Todos os direitos reservados.',
    nl: '© 2026 FireTrack. Alle rechten voorbehouden.',
    pl: '© 2026 FireTrack. Wszelkie prawa zastrzeżone.',
  },
  'footer.madeFor': {
    en: 'Made for the people who keep buildings safe.',
    de: 'Gemacht für die Menschen, die Gebäude sicher halten.',
    fr: 'Conçu pour ceux qui assurent la sécurité des bâtiments.',
    it: 'Fatto per chi mantiene gli edifici sicuri.',
    es: 'Hecho para las personas que mantienen los edificios seguros.',
    pt: 'Feito para as pessoas que mantêm os edifícios seguros.',
    nl: 'Gemaakt voor de mensen die gebouwen veilig houden.',
    pl: 'Stworzone dla ludzi, którzy dbają o bezpieczeństwo budynków.',
  },

  // Footer link groups (kept as-is since they're navigation labels)
  'footer.link.features': {
    en: 'Features',
    de: 'Funktionen',
    fr: 'Fonctionnalités',
    it: 'Funzionalità',
    es: 'Funciones',
    pt: 'Funcionalidades',
    nl: 'Functies',
    pl: 'Funkcje',
  },
  'footer.link.pricing': {
    en: 'Pricing',
    de: 'Preise',
    fr: 'Tarifs',
    it: 'Prezzi',
    es: 'Precios',
    pt: 'Preços',
    nl: 'Prijzen',
    pl: 'Cennik',
  },
  'footer.link.integrations': {
    en: 'Integrations',
    de: 'Integrationen',
    fr: 'Intégrations',
    it: 'Integrazioni',
    es: 'Integraciones',
    pt: 'Integrações',
    nl: 'Integraties',
    pl: 'Integracje',
  },
  'footer.link.changelog': {
    en: 'Changelog',
    de: 'Changelog',
    fr: 'Changelog',
    it: 'Changelog',
    es: 'Changelog',
    pt: 'Changelog',
    nl: 'Changelog',
    pl: 'Changelog',
  },
  'footer.link.roadmap': {
    en: 'Roadmap',
    de: 'Roadmap',
    fr: 'Feuille de route',
    it: 'Roadmap',
    es: 'Hoja de ruta',
    pt: 'Roteiro',
    nl: 'Roadmap',
    pl: 'Plan rozwoju',
  },
  'footer.link.documentation': {
    en: 'Documentation',
    de: 'Dokumentation',
    fr: 'Documentation',
    it: 'Documentazione',
    es: 'Documentación',
    pt: 'Documentação',
    nl: 'Documentatie',
    pl: 'Dokumentacja',
  },
  'footer.link.blog': {
    en: 'Blog',
    de: 'Blog',
    fr: 'Blog',
    it: 'Blog',
    es: 'Blog',
    pt: 'Blog',
    nl: 'Blog',
    pl: 'Blog',
  },
  'footer.link.complianceGuides': {
    en: 'Compliance Guides',
    de: 'Compliance-Leitfäden',
    fr: 'Guides de conformité',
    it: 'Guide alla conformità',
    es: 'Guías de cumplimiento',
    pt: 'Guias de conformidade',
    nl: 'Compliance-gidsen',
    pl: 'Przewodniki zgodności',
  },
  'footer.link.apiReference': {
    en: 'API Reference',
    de: 'API-Referenz',
    fr: 'Référence API',
    it: 'Riferimento API',
    es: 'Referencia API',
    pt: 'Referência API',
    nl: 'API-referentie',
    pl: 'Dokumentacja API',
  },
  'footer.link.status': {
    en: 'Status',
    de: 'Status',
    fr: 'Statut',
    it: 'Stato',
    es: 'Estado',
    pt: 'Status',
    nl: 'Status',
    pl: 'Status',
  },
  'footer.link.about': {
    en: 'About',
    de: 'Über uns',
    fr: 'À propos',
    it: 'Chi siamo',
    es: 'Acerca de',
    pt: 'Sobre',
    nl: 'Over ons',
    pl: 'O nas',
  },
  'footer.link.careers': {
    en: 'Careers',
    de: 'Karriere',
    fr: 'Carrières',
    it: 'Lavora con noi',
    es: 'Empleo',
    pt: 'Carreiras',
    nl: 'Vacatures',
    pl: 'Kariera',
  },
  'footer.link.press': {
    en: 'Press',
    de: 'Presse',
    fr: 'Presse',
    it: 'Stampa',
    es: 'Prensa',
    pt: 'Imprensa',
    nl: 'Pers',
    pl: 'Media',
  },
  'footer.link.contact': {
    en: 'Contact',
    de: 'Kontakt',
    fr: 'Contact',
    it: 'Contatti',
    es: 'Contacto',
    pt: 'Contato',
    nl: 'Contact',
    pl: 'Kontakt',
  },
  'footer.link.privacy': {
    en: 'Privacy Policy',
    de: 'Datenschutz',
    fr: 'Politique de confidentialité',
    it: 'Privacy',
    es: 'Política de privacidad',
    pt: 'Política de privacidade',
    nl: 'Privacybeleid',
    pl: 'Polityka prywatności',
  },
  'footer.link.terms': {
    en: 'Terms of Service',
    de: 'Nutzungsbedingungen',
    fr: 'Conditions d\u2019utilisation',
    it: 'Termini di servizio',
    es: 'Términos de servicio',
    pt: 'Termos de serviço',
    nl: 'Gebruiksvoorwaarden',
    pl: 'Regulamin',
  },
  'footer.link.security': {
    en: 'Security',
    de: 'Sicherheit',
    fr: 'Sécurité',
    it: 'Sicurezza',
    es: 'Seguridad',
    pt: 'Segurança',
    nl: 'Beveiliging',
    pl: 'Bezpieczeństwo',
  },
  'footer.link.gdpr': {
    en: 'GDPR',
    de: 'DSGVO',
    fr: 'RGPD',
    it: 'GDPR',
    es: 'RGPD',
    pt: 'LGPD',
    nl: 'AVG',
    pl: 'RODO',
  },
  'footer.language': {
    en: 'Language',
    de: 'Sprache',
    fr: 'Langue',
    it: 'Lingua',
    es: 'Idioma',
    pt: 'Idioma',
    nl: 'Taal',
    pl: 'Język',
  },
} as const;

export type I18nKey = keyof typeof dict;

export function t(key: I18nKey, lang: Lang): string {
  const entry = dict[key];
  return entry?.[lang] ?? entry?.en ?? key;
}
